// 将秒数转换为时分秒格式
export const formatSeconds = (seconds: any) => {
  let ss = parseInt(seconds, 0); // 秒
  let mm = 0; // 分
  let hh = 0; // 小时
  if (ss > 60) {
    const temp: any = ss / 60;
    mm = parseInt(temp, 0);
    ss = ss % 60;
  }
  if (mm > 60) {
    const temp: any = mm / 60;
    hh = parseInt(temp, 0);
    mm = mm % 60;
  }
  let result = ('00' + ss).slice(-2);
  if (mm > 0) {
    result = ('00' + mm).slice(-2) + ':' + result;
  } else {
    result = '00:' + result;
  }
  if (hh > 0) {
    result = ('00' + hh).slice(-2) + ':' + result;
  }
  return result;
};

// 根据文件名后缀区分 文件类型
/*
 * @param: fileName - 文件名称
 * @param: 数据返回 1) 无后缀匹配 - false
 * @param: 数据返回 2) 匹配图片 - image
 * @param: 数据返回 3) 匹配 txt - txt
 * @param: 数据返回 4) 匹配 excel - excel
 * @param: 数据返回 5) 匹配 word - word
 * @param: 数据返回 6) 匹配 pdf - pdf
 * @param: 数据返回 7) 匹配 ppt - ppt
 * @param: 数据返回 8) 匹配 视频 - video
 * @param: 数据返回 9) 匹配 音频 - radio
 * @param: 数据返回 10) 其他匹配项 - other
 */
export const matchType = (fileName: any) => {
  // 后缀获取
  let suffix = '';
  let flag = false;
  // 获取类型结果
  let result = '';
  try {
    const flieArr = fileName.split('?')[0].split('.');
    suffix = flieArr[flieArr.length - 1].toLowerCase();
  } catch (err) {
    suffix = '';
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = '';
    return flag;
  }
  // 图片格式
  const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
  // 进行图片匹配
  flag = imglist.some((item) => {
    return item === suffix;
  });
  if (flag) {
    result = 'image';
    return result;
  }
  // 匹配txt
  const txtlist = ['txt'];
  flag = txtlist.some((item) => {
    return item === suffix;
  });
  if (flag) {
    result = 'txt';
    return result;
  }
  // 匹配 excel
  const excelist = ['xls', 'xlsx'];
  flag = excelist.some((item) => {
    return item === suffix;
  });
  if (flag) {
    result = 'excel';
    return result;
  }
  // 匹配 word
  const wordlist = ['doc', 'docx'];
  flag = wordlist.some((item) => {
    return item === suffix;
  });
  if (flag) {
    result = 'word';
    return result;
  }
  // 匹配 pdf
  const pdflist = ['pdf'];
  flag = pdflist.some((item) => {
    return item === suffix;
  });
  if (flag) {
    result = 'pdf';
    return result;
  }
  // 匹配 ppt
  const pptlist = ['ppt'];
  flag = pptlist.some((item) => {
    return item === suffix;
  });
  if (flag) {
    result = 'ppt';
    return result;
  }
  // 匹配 视频
  const videolist = ['mp4', 'm2v', 'mkv'];
  flag = videolist.some((item) => {
    return item === suffix;
  });
  if (flag) {
    result = 'video';
    return result;
  }
  // 匹配 音频
  const radiolist = ['mp3', 'wav', 'wmv'];
  flag = radiolist.some((item) => {
    return item === suffix;
  });
  if (result) {
    result = 'radio';
    return result;
  }
  // 其他 文件类型
  result = 'other';
  return result;
};

// 将base64转换为文件
export const dataURLtoFile = (dataurl: any, filename: any) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const suffix = mime.split('/')[1];
  if (!filename) {
    // 若无文件名则取当前时间戳
    filename = `${Date.now()}.${suffix}`;
  }
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

// 将base64转换为blob
export const dataURLtoBlob = (dataurl: any) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime,
  });
};
